import swal, { SweetAlertOptions } from 'sweetalert2';
import { browserStorage } from './browser-storage';
import { msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';

interface ConfirmOpts extends SweetAlertOptions {
  decisionKey: string;
  lingui: ReturnType<typeof useLingui>['_'];
}

export const confirmRemember = async (opts: ConfirmOpts) => {
  const storageKey = `coco:u:$user:decision:${opts.decisionKey}`;
  if (browserStorage.getItem(storageKey) === 'true') {
    return true;
  }
  const { isConfirmed } = await swal.fire({
    ...opts,
    showCancelButton: true,
    // eslint-disable-next-line lingui/no-unlocalized-strings
    footer: `${opts.footer ?? ''}<label for="coco-swal-confirm">
      <input type="checkbox" id="coco-swal-confirm"> ${opts.lingui(
      msg`Remember my decision`,
    )}
    </label>`,
    didOpen: () => {
      document
        .querySelector('#coco-swal-confirm')
        ?.addEventListener('change', (e: Event) => {
          if ((e.target as HTMLInputElement)?.checked) {
            browserStorage.setItem(storageKey, 'true');
          } else {
            browserStorage.setItem(storageKey, 'false');
          }
        });
    },
  });
  return isConfirmed;
};
